module.exports = __webpack_public_path__ + "static/media/MTL_BASE_SL2.a87c1431.png";